import React from "react";
import { Clock } from "@phosphor-icons/react";

export function ResultCard({ result, dateDisplay, loading }) {
  const fr = result?.fr;
  const sr = result?.sr;
  const available = result?.available;

  return (
    <div
      className="rounded-2xl overflow-hidden bg-white border border-slate-100 shadow-[0_10px_40px_-10px_rgba(76,29,149,0.18)]"
      data-testid="result-card"
    >
      {/* Purple header */}
      <div className="relative bg-gradient-to-r from-brand-900 via-brand to-brand-hover px-5 py-3.5 text-center">
        <div className="absolute inset-0 opacity-20 bg-[radial-gradient(circle_at_20%_20%,white,transparent_40%)]" />
        <h2 className="relative font-heading text-xl sm:text-2xl font-black text-white tracking-tight">
          Morning Teer
        </h2>
        {dateDisplay && (
          <p className="relative text-violet-200 text-xs font-semibold mt-0.5" data-testid="result-date">
            {dateDisplay}
          </p>
        )}
      </div>

      {/* Column headers */}
      <div className="grid grid-cols-2 divide-x divide-slate-200 border-b border-slate-200 bg-slate-50">
        {[
          { label: "F/R", time: "10:30 AM" },
          { label: "S/R", time: "11:30 AM" },
        ].map((c) => (
          <div key={c.label} className="py-2 text-center">
            <div className="flex items-center justify-center gap-1.5 text-slate-700">
              <span className="font-heading font-extrabold text-sm sm:text-base">{c.label}</span>
              <span className="inline-flex items-center gap-1 text-xs font-semibold text-slate-500">
                <Clock className="w-3.5 h-3.5" weight="bold" />
                {c.time}
              </span>
            </div>
          </div>
        ))}
      </div>

      {/* Numbers */}
      <div className="grid grid-cols-2 divide-x divide-slate-200">
        {[fr, sr].map((n, i) => (
          <div key={i} className="py-3 sm:py-4 flex items-center justify-center min-h-[80px]">
            {loading ? (
              <div className="h-11 w-20 rounded-lg bg-slate-100 animate-pulse" />
            ) : available && n ? (
              <span
                className="font-heading text-4xl sm:text-5xl font-black text-brand tracking-tighter tabular-nums"
                data-testid={i === 0 ? "result-fr-number" : "result-sr-number"}
              >
                {n}
              </span>
            ) : (
              <span className="text-slate-300 font-heading text-3xl sm:text-4xl font-black" data-testid={i === 0 ? "result-fr-number" : "result-sr-number"}>
                --
              </span>
            )}
          </div>
        ))}
      </div>

      {!loading && !available && (
        <div className="px-5 pb-5 -mt-2">
          <p className="text-center text-sm text-slate-500 bg-slate-50 rounded-xl py-3" data-testid="result-pending">
            Today's result has not been published yet. Please check back soon.
          </p>
        </div>
      )}
    </div>
  );
}
